import { combineReducers } from 'redux';
import { createRequestReducer } from 'shared/hooks/redux/hooks';
import { version_code } from 'webui/utils/version';
const initialState = {
    running_key: null,
    current_step_index: 0,
    current_step_key: '',
};
function learningReducer(state = initialState, action) {
    switch (action.type) {
        case 'RUN_LEARNING':
            return {
                ...state,
                running_key: action.key,
                current_step_index: 0,
                current_step_key: '',
            };
        case 'STOP_LEARNING':
            return { ...state, running_key: null };
        case 'SET_LEARNING_INDEX':
            return {
                ...state,
                current_step_index: action.index,
                current_step_key: action.key,
            };
        default:
            return state;
    }
}
function availableUiGuideGroups(PRELOAD) {
    const current_version = version_code(UI_VERSION);
    const available_groups = (PRELOAD.ui_guide_groups ?? []).filter((group) => group.min_app_version == null
        ? true
        : version_code(group.min_app_version) <= current_version);
    return (state = available_groups) => state;
}
const storeHelperInitialState = {
    next: null,
};
function storeHelperReducer(state = storeHelperInitialState, action) {
    switch (action.type) {
        case 'INITIAL_STORE_HELPER': {
            const { type, ...rest } = action;
            return { ...state, ...rest };
        }
        default:
            return state;
    }
}
export const uiGuideReducer = (PRELOAD) => combineReducers({
    ui_guide_groups: createRequestReducer('UI_GUIDE_GROUPS'),
    learning: learningReducer,
    available_ui_guide_groups: availableUiGuideGroups(PRELOAD),
    store_helpers: storeHelperReducer,
});
